import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FileText, Github } from 'lucide-react';

const Research = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const TechGrid = () => (
    <div className="absolute inset-0 z-0">
      <div className="absolute w-full h-full grid grid-cols-12 gap-px opacity-5">
        {[...Array(12)].map((_, i) => (
          <div key={i} className="border-r border-gray-300 h-full"></div>
        ))}
      </div>
      <div className="absolute w-full h-full grid grid-rows-12 gap-px opacity-5">
        {[...Array(12)].map((_, i) => (
          <div key={i} className="border-b border-gray-300 w-full"></div>
        ))}
      </div>
    </div>
  );

  const ScanLine = () => (
    <motion.div
      className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-400/10 to-transparent h-32"
      animate={{ top: ['-10%', '110%'] }}
      transition={{ duration: 4, repeat: Infinity, ease: 'linear' }}
    />
  );

  return (
    <section className="relative pt-32 pb-24 bg-black overflow-hidden min-h-screen">
      <TechGrid />
      <ScanLine />

      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gray-700/30 to-transparent"></div>
      <div className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-r from-transparent via-gray-700/30 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto">
          <motion.h1
            className="text-4xl md:text-5xl font-extralight tracking-wider text-white mb-6"
            style={{ fontFamily: 'Georgia, Cambria, serif' }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Research
          </motion.h1>

          <motion.p
            className="text-gray-400 leading-relaxed mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            We're an early-stage R&D company researching neuromorphic computing for cybersecurity
            applications and post-quantum cryptography. As our work matures, we'll publish it here.
          </motion.p>

          <div className="space-y-4">
            <motion.div
              className="flex items-start gap-4 p-6 bg-gray-900/40 border border-gray-800/50 rounded-lg"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <FileText className="w-6 h-6 text-gray-400 flex-shrink-0 mt-1" strokeWidth={1.5} />
              <div>
                <h3 className="text-white font-medium mb-1">Published preprints</h3>
                <p className="text-gray-500 text-sm">See arXiv for published preprints.</p>
              </div>
            </motion.div>

            <motion.div
              className="flex items-start gap-4 p-6 bg-gray-900/40 border border-gray-800/50 rounded-lg"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <Github className="w-6 h-6 text-gray-400 flex-shrink-0 mt-1" strokeWidth={1.5} />
              <div>
                <h3 className="text-white font-medium mb-1">Open source projects</h3>
                <p className="text-gray-500 text-sm">See our GitHub for open-source projects.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Research;
